var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAntioxidants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.727a2.227 2.227 0 1 0 0-4.454 2.227 2.227 0 0 0 0 4.454ZM4.917 5.86a1.113 1.113 0 1 0 0-2.226 1.113 1.113 0 0 0 0 2.227ZM4.917 13.86a1.113 1.113 0 1 0 0-2.226 1.113 1.113 0 0 0 0 2.227ZM11.927 5.86a1.113 1.113 0 1 0 0-2.226 1.113 1.113 0 0 0 0 2.227ZM11.927 13.86a1.113 1.113 0 1 0 0-2.226 1.113 1.113 0 0 0 0 2.227Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.258 8.088 4.929 4.507l-.175.162 3.33 3.581.174-.162ZM11.95 12.629 9.005 8.728l-.19.143 2.946 3.902.19-.144ZM13.743 11.305a1.113 1.113 0 1 0 0-2.227 1.113 1.113 0 0 0 0 2.227Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.69 10.083 8.988 8.745l-.065.23 4.702 1.337.065-.23ZM8.462 9.328l-3.58 3.328.162.175 3.58-3.329-.162-.174ZM11.833 4.54 8.43 8.05l.171.167 3.403-3.51-.17-.167Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntioxidants);
export default __webpack_public_path__ + "static/media/antioxidants.a8188ce395e63228bb777148c341b03d.svg";
export { ForwardRef as ReactComponent };